import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentDataDestService } from '../../component-data-dest.service';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface UpdateEventExtraPayload {
  category: string | null;
  smoke_development: boolean;
  cleaning: boolean;
  cash_list_required: boolean;
  certificates_created: boolean;
  cash_list_packed_date: string | null;
}

export const update_event_extra = (
  service: ComponentDataDestService,
  _componentDataSourceService: ComponentDataSourceService,
  data: UpdateEventExtraPayload
): Observable<unknown> => {
  const router = service.injector.get(Router);
  const urlWithoutQuery = (router.url || '').split('?')[0];
  const eventGuid = urlWithoutQuery
    .split('/')
    .find((segment: string) => UUID_REGEX.test(segment));

  if (!eventGuid) {
    return new Observable((observer) => {
      observer.error(new Error('No valid event GUID found in URL'));
    });
  }

  return service.http.patch(
    `${environment.apiUrl}/events/${eventGuid}/extra-settings`,
    data
  );
};
